import CryptoJS from 'crypto-js';

const tools = {
	data: {
		set(cacheKey: string, data: any, expireIn: number = 0) {
			let cacheValue = {
				content: data,
				expireIn: expireIn === 0 ? 0 : new Date().getTime() + expireIn * 1000
			}
			return localStorage.setItem(cacheKey, tools.base64.encrypt(JSON.stringify(cacheValue)))
		},
		get(cacheKey: string) {
			try {
				const cacheValue = JSON.parse(tools.base64.decrypt(localStorage.getItem(cacheKey)))
				if (cacheValue) {
					let nowTime = new Date().getTime()
					if (nowTime > cacheValue.expireIn && cacheValue.expireIn !== 0) {
						localStorage.removeItem(cacheKey)
						return null;
					}
					return cacheValue.content
				}
				return null
			} catch (err) {
				return null
			}
		},
		remove(cacheKey: string) {
			return localStorage.removeItem(cacheKey)
		},
		clear() {
			return localStorage.clear()
		}
	},
	base64: {
		encrypt(data: string) {
			return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(data))
		},
		decrypt(cipher: string) {
			return CryptoJS.enc.Base64.parse(cipher).toString(CryptoJS.enc.Utf8)
		}
	},
	go: async function (fn: Function) {
		try {
			let res = await fn
			return [res, null]
		} catch (err) {
			return [null, err]
		}
	},
	crypto: {
		//MD5加密
		MD5(data: string) {
			return CryptoJS.MD5(data).toString()
		},
	},
	makeMenu: function (menus, pid = 0) {
		const arr = [];
		for (let item of menus) {
			if (item.pid === pid) {
				// 数据格式处理
				const tmp = {
					name: item['name'],
					path: '/' + item['path'],
					component: item['path'],
					meta: {
						'title': item['title'],
						'icon': item['icon'],
						'hidden': item['hidden'],
						'type': 'menu'
					}
				};
				const children = this.makeMenu(menus, item.menu_id);
				if (children.length > 0) {
					tmp['children'] = children
				}
				arr.push(tmp)
			}
		}
		return arr
	},
	screen: function (element) {
		var isFull = !!(document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement || document.fullscreenElement);
		if (isFull) {
			if (document.exitFullscreen) {
				document.exitFullscreen();
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen();
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen();
			} else if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen();
			}
		} else {
			if (element.requestFullscreen) {
				element.requestFullscreen();
			} else if (element.msRequestFullscreen) {
				element.msRequestFullscreen();
			} else if (element.mozRequestFullScreen) {
				element.mozRequestFullScreen();
			} else if (element.webkitRequestFullscreen) {
				element.webkitRequestFullscreen();
			}
		}
	},
	/* 复制对象 */
	objCopy: function (obj) {
		return JSON.parse(JSON.stringify(obj || []));
	},
	/* 日期格式化 */
	dateFormat: function (date, fmt = 'yyyy-MM-dd hh:mm:ss') {
		date = new Date(date)
		var o = {
			"M+": date.getMonth() + 1,                 //月份
			"d+": date.getDate(),                    //日
			"h+": date.getHours(),                   //小时
			"m+": date.getMinutes(),                 //分
			"s+": date.getSeconds(),                 //秒
			"q+": Math.floor((date.getMonth() + 3) / 3), //季度
			"S": date.getMilliseconds()             //毫秒
		};
		if (/(y+)/.test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
		}
		for (var k in o) {
			if (new RegExp("(" + k + ")").test(fmt)) {
				fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
			}
		}
		return fmt;
	},
	makeTreeData: function (data, pid = 0, key = "id", parent = "pid") {
		const arr = [];
		for (let item of data) {
			if (item[parent] == pid) {
				// 数据格式处理
				const tmp = item;
				const children = tools.makeTreeData(data, item[key], key, parent);
				if (children.length > 0) {
					tmp['children'] = children
				}
				arr.push(tmp)
			}
		}
		return arr
	},
	getBrowser(userAgent: string) {
		// 检测浏览器类型和版本
		if (/Opera|OPR/.test(userAgent)) {
			return 'Opera';
		} else if (/Edg/.test(userAgent)) {
			return 'Edge';
		} else if (/Chrome/.test(userAgent)) {
			return 'Chrome';
		} else if (/Safari/.test(userAgent)) {
			return 'Safari';
		} else if (/Firefox/.test(userAgent)) {
			return 'Firefox';
		} else if (/MSIE|Trident/.test(userAgent)) {
			return 'IE';
		} else {
			return '未知'
		}
	},
	getTimeByNum(num) {
		var times = {
			1: '00:00~00:30',
			2: '00:30~01:00',
			3: '01:00~01:30',
			4: '01:30~02:00',
			5: '02:00~02:30',
			6: '02:30~03:00',
			7: '03:00~03:30',
			8: '03:30~04:00',
			9: '04:00~04:30',
			10: '04:30~05:00',
			11: '05:00~05:30',
			12: '05:30~06:00',
			13: '06:00~06:30',
			14: '06:30~07:00',
			15: '07:00~07:30',
			16: '07:30~08:00',
			17: '08:00~08:30',
			18: '08:30~09:00',
			19: '09:00~09:30',
			20: '09:30~10:00',
			21: '10:00~10:30',
			22: '10:30~11:00',
			23: '11:00~11:30',
			24: '11:30~12:00',
			25: '12:00~12:30',
			26: '12:30~13:00',
			27: '13:00~13:30',
			28: '13:30~14:00',
			29: '14:00~14:30',
			30: '14:30~15:00',
			31: '15:00~15:30',
			32: '15:30~16:00',
			33: '16:00~16:30',
			34: '16:30~17:00',
			35: '17:00~17:30',
			36: '17:30~18:00',
			37: '18:00~18:30',
			38: '18:30~19:00',
			39: '19:00~19:30',
			40: '19:30~20:00',
			41: '20:00~20:30',
			42: '20:30~21:00',
			43: '21:00~21:30',
			44: '21:30~22:00',
			45: '22:00~22:30',
			46: '22:30~23:00',
			47: '23:00~23:30',
			48: '23:30~24:00'
		}
		return times[num]
	}
}

export default tools
